<template>
    <div class="question_number">
        <template v-if="isQuestionPreview">
            <div class="question_header">
                <div class="question_search">
                    <span>
                        <input 
                            type="text" 
                            autocomplete="off" 
                            v-model="keySearchQuestionId" 
                            v-on:keyup="searchQuestion" 
                            :placeholder="$t('manage_questions.questions_id')" 
                            class="question_id questions_type"
                            style="width: 29%;"
                        />
                    </span>
                    <span>
                        <input 
                            type="text" 
                            autocomplete="off" 
                            v-model="keySearchQuestion" 
                            v-on:keyup="searchQuestion" 
                            :placeholder="$t('search.keyWord')" 
                            class="question_id"
                            style="width: 70%;"
                        />
                    </span>
                </div>
                <div class="select-option">
                    <span class="select-new-questions">
                        <select v-model="questionsType" @change="searchQuestion" class="questions_type" :class="{my_select_organization_disabled:questionsType==''}" style="width: 26%;">
                            <option value="" class="ds">{{$t('manage_questions.chosse_questions')}}</option>
                            <option value="1" class="ds">{{$t('manage_questions.chosse_questions_one')}}</option>
                            <option value="2" class="ds">{{$t('manage_questions.chosse_questions_more')}}</option>
                            <option value="3" class="ds">{{$t('manage_questions.questions_writing')}}</option>
                            <option value="4" class="ds">{{$t('manage_questions.chosse_answer_more')}}</option>
                        </select>
                    </span>
                    <span class="select-new-questions">
                        <select v-model="statusQuestionsType" @change="searchQuestion" class="questions_type" :class="{my_select_statusQuestionsType_disabled:statusQuestionsType==''}" style="width: 16%;">
                            <option value="" class="ds">{{$t('manage_questions.chosse_status_questions')}}</option>
                            <option value="2" class="ds">{{$t('manage_questions.questions_exercise')}}</option>
                            <option value="1" class="ds">{{$t('manage_questions.questions_test')}}</option>
                        </select>
                    </span>
                    <span class="select-new-questions">
                        <select v-model="teacherCreate" @change="searchQuestion" class="questions_type" :class="{my_select_teachetCeate_disabled:teacherCreate==''}" style="width: 29%;">
                            <option value="" class="ds">{{$t('manage_questions.chosse_teacher_create')}}</option>
                            <option 
                                class="ds" 
                                v-for="item in listCreateTeacherName" 
                                :key="item" 
                                :value="item"
                            >
                                {{ item }}
                            </option>
                        </select>
                    </span>
                    <span class="date">
                        <el-date-picker
                            value-format="yyyy-MM-dd"
                            v-model="dateCreate"
                            type="date"
                            @change="searchQuestion"
                            :placeholder="$t('manage_lesson.choose_date')"
                            class="questions_type"
                            style="width: 27%;"
                        ></el-date-picker>
                    </span>
                </div>
                <div class="task_answer_radio task_answer_checkbox">
                    <span class="select-new-questions">
                        <select v-model="chapter" @change="searchQuestion" class="questions_type" :class="{my_select_chapter_disabled:chapter==''}" style="width: 30%;">
                            <option value="" class="ds">{{$t('manage_questions.chosse_chapter')}}</option>
                            <option 
                                class="ds" 
                                v-for="item in listChapterName" 
                                :key="item" 
                                :value="item"
                            >
                                {{ item }}
                            </option>
                        </select>
                    </span>
                    <span>
                        <input class="ip-check"
                            v-model="checkedValueAudio"
                            id="checkbox_a"
                            type="checkbox"
                            value=""
                            @change="searchQuestion"
                        />
                        <label for="checkbox_a">{{$t('manage_questions.questions_audio')}}</label>
                    </span>
                    <span>
                        <input class="ip-check"
                            v-model="checkedValueVideo"
                            id="checkbox_b"
                            type="checkbox"
                            value=""
                            @change="searchQuestion"
                        />
                        <label for="checkbox_b">{{$t('manage_questions.questions_video')}}</label>
                    </span>
                    <span>
                        <input class="ip-check"
                            v-model="checkedValueImage"
                            id="checkbox_c"
                            type="checkbox"
                            value=""
                            @change="searchQuestion"
                        />
                        <label for="checkbox_c">{{$t('manage_questions.questions_image')}}</label>
                    </span>
                </div>
                <div>
                    <el-button
                        class="btn-login reset-form-search-questions"
                        style="border-radius: 20px;"
                        @click="reset()"
                    >
                    {{ $t("manage_lesson.clear") }}
                    </el-button>
                </div>
            </div>
            <div class="" v-for="(item, index) in listQuestinon" :key="index">
                <!-- option 2 -->
                <table class="title_question_s" :class="{active_click:previewQA.questionId==item.questionId}" :id="item.questionId" @click="buttonPreviewQA(item)" style="width: 100%;">
                    <tr>
                        <th class="title_question_s_header">
                            <!-- icon type question -->
                            <td class="td_padding" v-if="item.questionTypeId==1"><img class="icon_status_question" src="../../../static/images/IC-1DA-xanh2.png"/></td>
                            <td class="td_padding" v-else-if="item.questionTypeId==2"><img class="icon_status_question" src="../../../static/images/IC-NhieuDA-xanh2.png"/></td>
                            <td class="td_padding" v-else><img class="icon_status_question" src="../../../static/images/IC-vietcautraloi-xanh.png"/></td>
                            <!-- ID -->
                            <td class="td_padding">{{item.questionId}}</td>
                            <!-- Date -->
                            <td class="td_padding">{{item.date_new}}</td>
                            <!-- name -->
                            <td class="td_padding">{{item.createTeacherName}}</td>
                            <!-- icon status question -->
                            <td v-if="item.audioName != undefined 
                                && item.audioName != null 
                                && item.audioName != '' 
                                && 'mp3' == item.audioName.substring(item.audioName.lastIndexOf('.') + 1)"
                                class="td_icon_type_status_question"
                            >
                                <img class="icon_type_status_question" src="../../../static/images/IC-Audio-xanh.png"/>
                            </td>
                            <td v-else-if="item.audioName != undefined 
                                && item.audioName != null 
                                && item.audioName != '' 
                                && 'mp4' == item.audioName.substring(item.audioName.lastIndexOf('.') + 1)"
                                class="td_icon_type_status_question"
                            >
                                <img class="icon_type_status_question" src="../../../static/images/IC-Video-xanh.png"/>
                            </td>
                            <td v-else-if="item.questionContent.match(checkItemImage)"
                                class="td_icon_type_status_question"
                            >
                                <img class="icon_type_status_question" src="../../../static/images/IC-Image-xanh.png"/>
                            </td>
                            <td v-else
                                class="td_icon_type_status_question"
                            >
                                <!-- <img class="icon_type_status_question" style="width:19px" src="../../../static/images/IC-Text-xanh.png"/> -->
                            </td>
                        </th>
                    </tr>
                    <tr>
                        <td class="test_content" style="-webkit-box-orient: vertical!important;">{{item.content_new}}</td>
                    </tr>
                </table>
                <!-- option 2 -->
            </div>
        </template>
        <template v-if="!isQuestionPreview">
            <div class="title_content_questions">
                <h1 class="manage-title-content">ID: {{previewQA.questionId}}</h1>
                <button class="btn-tast btn-next-1" @click="back()">
                    <img src="../../../static/images/icon-back-1.png"/>
                    <span class="nqt-text">{{ $t("common.returnButton") }}</span>
                </button>
            </div>
            <previewQuestion :data="previewQA"></previewQuestion>
        </template>
        <loading class="loading--lesson" :showLoading="!isLoadData" />
    </div>
</template>

<script>
import previewQuestion from "@/components/manage/previewQuestion";
import loading from "@/components/loading/loading";
export default {
    data() {
        return {
            isLoadData: false,
            isQuestionPreview: true,
            previewQA: {},
            listQuestinon: [],
            listCurrent: [],
            listKeysearchChecked: [],
            listTeacher: [],
            keySearchQuestion: "",
            keySearchQuestionId: "",
            isCheck: false,
            checkedValueAudio: false,
            checkedValueVideo: false,
            checkedValueImage: false,
            checkedValueCreator: false,
            dateCreate: null,
            questionsType: "",
            statusQuestionsType: "",
            teacherCreate: "",
            listCreateTeacherName: [],
            listCreateTeacherNameCurrent: [],
            checkItemImage: /<img[^>]+src\s*=\s*['"]([^'"]+)['"][^>]*>/g,
            chapter:"",
            listChapterName:[],
            listChapterNameCurrent:[],
        };
    },
    components: {
        previewQuestion,
        loading
    },
    props: {
        data: {}
    },
    updated () {},
    watch: {},
    mounted() {
        this.init();
        this.getListQuesttions();
        this.getListCurrentQuesttions();
    },
    methods: {
        init(){
            if (this.data.listQuestion==null) {
                this.$api.post("/studyCourseQuestion/getCourseQuestionsList", {
                    courseId: this.data.courseId
                })
                .then(response => {
                    this.$emit("listQuestionsCourse", response.data);
                    this.addArrayQuestions(response.data);
                    this.isLoadData = true;
                });
            } else {
                this.isLoadData = true;
                this.addArrayQuestions(this.data.listQuestion);
            }
        },
        addArrayQuestions(param){
            param.forEach((item) => {
                this.listCreateTeacherNameCurrent.push(item.createTeacherName);
                this.listQuestinon.push(item);
                this.listCurrent.push(item);
                /// chapter
                this.listChapterNameCurrent.push(item.chapterName);
            });
            this.listQuestinon.forEach((value) =>{
                value['date_new'] = value.createDay.substr(0, 10);
                value['content_new'] = $(value.questionContent).text();
            });
            this.listCurrent.forEach((value) =>{
                value['date_new'] = value.createDay.substr(0, 10);
                value['content_new'] = $(value.questionContent).text();
            });
            /// if this.listCreateTeacherName == 0 
            if(this.listCreateTeacherName == 0){
                let resutl = [];
                this.listCreateTeacherNameCurrent.forEach(function(item) {
                    if(resutl.indexOf(item) < 0) {
                        resutl.push(item);
                    }
                });
                this.listCreateTeacherName = resutl;
            } else{
                // if this.listCreateTeacherName > 0
                let listLenghtNotNull = this.listCreateTeacherName;
                this.listChapterNameCurrent.forEach(function(item) {
                    if(listLenghtNotNull.indexOf(item) < 0) {
                        listLenghtNotNull.push(item);
                    }
                });
                this.listCreateTeacherName = listLenghtNotNull;
            }
            /// chapter if this.listCreateTeacherName == 0 
            if(this.listChapterName == 0){
                let resutl = [];
                this.listChapterNameCurrent.forEach(function(item) {
                    if(resutl.indexOf(item) < 0) {
                        resutl.push(item);
                    }
                });
                this.listChapterName = resutl;
            } else{
                // chapter if this.listCreateTeacherName > 0
                let listLenghtNotNull = this.listChapterName;
                this.listCreateTeacherNameCurrent.forEach(function(item) {
                    if(listLenghtNotNull.indexOf(item) < 0) {
                        listLenghtNotNull.push(item);
                    }
                });
                this.listChapterName = listLenghtNotNull;
            }
        },
        getListQuesttions(){
            this.listQuestinon.forEach((value) =>{
                value['date_new'] = value.createDay.substr(0, 10);
                value['content_new'] = $(value.questionContent).text();
            });
        },
        getListCurrentQuesttions(){
            this.listCurrent.forEach((value) =>{
                value['date_new'] = value.createDay.substr(0, 10);
                value['content_new'] = $(value.questionContent).text();
            });
        },
        buttonPreviewQA(value) {
            $(".manage--content").animate({ scrollTop: 0 }, "slow");
            this.previewQA = value;
            this.isQuestionPreview = false;
            this.$emit("update-type", 1);
        },
        back() {
            setTimeout(() => {
                  this.scrollQuestions(this.previewQA.questionId);
            }, 100);
            this.isQuestionPreview = true;
            this.$emit("update-type", 0);
        },
        scrollQuestions(id){
            let element = document.getElementById(id);
            element.scrollIntoView({behavior: "smooth"});
        },
        searchQuestion() {
            this.isCheck = false;
            this.listKeysearchChecked = [];
            let listSearch = this.listCurrent;
            let keyword = this.keySearchQuestion.toUpperCase();
            let keywordId = this.keySearchQuestionId.toUpperCase();
            if((keyword==null||keyword=="")
                &&(keywordId==null||keywordId=="")
                &&!this.checkedValueAudio
                &&!this.checkedValueVideo
                &&!this.checkedValueImage
                &&!this.dateCreate
                &&!this.teacherCreate
                &&!this.questionsType
                &&!this.statusQuestionsType
                &&!this.chapter
            ){
                this.listQuestinon = this.listCurrent;
                return;
            } else {
                /// search date
                let listDate = [];
                if(this.dateCreate) 
                {
                    listSearch.forEach((value) =>{
                        if(this.listKeysearchChecked.length==0)
                        {
                            if(value.createDay.substr(0, 10)==this.dateCreate)
                            {
                                this.listKeysearchChecked.push(value);
                                listDate.push(value);
                            }
                        } else 
                        {
                            let arrDateCreate = [];
                            this.listKeysearchChecked.forEach((item) => {
                                if(value.questionId==item.questionId)
                                {
                                    arrDateCreate.push(item);
                                }
                            });
                            if(arrDateCreate.length==0)
                            {
                                if(value.createDay.substr(0, 10)==this.dateCreate)
                                {
                                    this.listKeysearchChecked.push(value);
                                    listDate.push(value);
                                }
                            }
                        }
                    });
                    this.isCheck = true;
                }
                if(listDate.length > 0) 
                {
                    listSearch = listDate;
                }
                if(listDate.length==0&&this.dateCreate) 
                {
                    listSearch = [];
                }
                // search teacher
                let listTeacherCreate = [];
                if(this.teacherCreate) 
                {
                    this.listKeysearchChecked = [];
                    listSearch.forEach((value) =>{
                        if(value.createTeacherName==this.teacherCreate)
                        {
                            this.listKeysearchChecked.push(value);
                            listTeacherCreate.push(value);
                        }
                    });
                    this.isCheck = true;
                }
                if(listTeacherCreate.length > 0) 
                {
                    listSearch = listTeacherCreate;
                }
                if(listTeacherCreate.length==0&&this.teacherCreate) 
                {
                    listSearch = [];
                }
                // search chương
                let listChapterCreate = [];
                if(this.chapter) 
                {
                    this.listKeysearchChecked = [];
                    listSearch.forEach((value) =>{
                        if(value.chapterName==this.chapter)
                        {
                            this.listKeysearchChecked.push(value);
                            listChapterCreate.push(value);
                        }
                    });
                    this.isCheck = true;
                }
                if(listChapterCreate.length > 0) 
                {
                    listSearch = listChapterCreate;
                }
                if(listChapterCreate.length==0&&this.chapter) 
                {
                    listSearch = [];
                }
                /// search type
                let listTypeQuestions = [];
                if(this.questionsType) 
                {
                    this.listKeysearchChecked = [];
                    listSearch.forEach((value) =>{
                        if(value.questionTypeId==this.questionsType) 
                        {
                            this.listKeysearchChecked.push(value);
                            listTypeQuestions.push(value);
                        }
                    });
                    this.isCheck = true;
                }
                if(listTypeQuestions.length > 0) 
                {
                    listSearch = listTypeQuestions;
                }
                if(listTypeQuestions.length==0&&this.questionsType) 
                {
                    listSearch = [];
                }
                /// search status type questions
                let listStatusTypeQuestions = [];
                if(this.statusQuestionsType) 
                {
                    this.listKeysearchChecked = [];
                    listSearch.forEach((value) =>{
                        if(value.statusQuestionsType==this.statusQuestionsType) 
                        {
                            this.listKeysearchChecked.push(value);
                            listStatusTypeQuestions.push(value);
                        }
                    });
                    this.isCheck = true;
                }
                if(listStatusTypeQuestions.length > 0) 
                {
                    listSearch = listStatusTypeQuestions;
                }
                if(listStatusTypeQuestions.length==0&&this.statusQuestionsType) 
                {
                    listSearch = [];
                }
                ///
                if(this.checkedValueAudio||this.checkedValueVideo||this.checkedValueImage) 
                {
                    this.listKeysearchChecked = [];
                }
                /// search audio
                if(this.checkedValueAudio)
                {
                    listSearch.forEach((value) =>{
                        if(value.audioName != undefined 
                            && value.audioName != null 
                            && value.audioName != '' 
                            && 'mp3' == value.audioName.substring(value.audioName.lastIndexOf('.') + 1))
                        {
                            this.listKeysearchChecked.push(value);
                        }
                    });
                    this.isCheck = true;
                }
                /// search video
                if(this.checkedValueVideo)
                {
                    listSearch.forEach((value) =>{
                        if(value.audioName != undefined 
                            && value.audioName != null 
                            && value.audioName != '' 
                            && 'mp4' == value.audioName.substring(value.audioName.lastIndexOf('.') + 1))
                        {
                            this.listKeysearchChecked.push(value);
                        }
                    });
                    this.isCheck = true;
                }
                /// search image
                if(this.checkedValueImage)
                {
                    listSearch.forEach((value) =>{
                        let regexp = /<img[^>]+src\s*=\s*['"]([^'"]+)['"][^>]*>/g;
                        let image = value.questionContent.match(regexp);
                        if(image!=null)
                        {
                            if(value.audioName==null||value.audioName==undefined||value.audioName=='')
                            {
                                this.listKeysearchChecked.push(value);
                            } else 
                            {
                                if(this.listKeysearchChecked.length==0)
                                {
                                    this.listKeysearchChecked.push(value);
                                } else 
                                {
                                    let arrIMG = [];
                                    this.listKeysearchChecked.forEach((item) => {
                                        if(value.questionId==item.questionId)
                                        {
                                            arrIMG.push(item);
                                        }
                                    });
                                    if(arrIMG.length==0)
                                    {
                                        this.listKeysearchChecked.push(value);
                                    }
                                }
                            }
                        }
                    });
                    this.isCheck = true;
                }
                /// search content and id questions
                if(!this.isCheck)
                {
                    let listKeyWord = this.listCurrent;
                    let listIdQuestions = listKeyWord.filter(contentQuestions => contentQuestions.questionId.toString().toUpperCase().indexOf(keywordId) > -1);
                    if(listIdQuestions.length>0)
                    {
                        listKeyWord = listIdQuestions;
                    } else 
                    {
                        listKeyWord = [];
                    }
                    this.listQuestinon = listKeyWord.filter(contentQuestions => contentQuestions.content_new.toUpperCase().indexOf(keyword) > -1);
                    this.getListQuesttions();
                } else 
                {
                    let listIdQuestions = this.listKeysearchChecked.filter(contentQuestions => contentQuestions.questionId.toString().toUpperCase().indexOf(keywordId) > -1);
                    if(listIdQuestions.length>0)
                    {
                        this.listKeysearchChecked = listIdQuestions;
                    } else 
                    {
                        this.listKeysearchChecked = [];
                    }
                    this.listQuestinon = this.listKeysearchChecked.filter(contentQuestions => contentQuestions.content_new.toUpperCase().indexOf(keyword) > -1);
                    this.getListQuesttions();
                }
            }
        },
        reset() {
            this.chapter = "";
            this.keySearchQuestion = "";
            this.keySearchQuestionId = "";
            this.isCheck = false;
            this.checkedValueAudio = false;
            this.checkedValueVideo = false;
            this.checkedValueImage = false;
            this.teacherCreate = "";
            this.dateCreate = null;
            this.questionsType = "";
            this.statusQuestionsType = "";
            this.searchQuestion();
        }
    }
};
</script>
<style scoped>
    .id_questions .content_id_questions {
        font-size: 15px;
        font-weight: bold;
    }
    .title_content_questions {
        display:flex;
        top:5px;
        right:20px;
        justify-content: space-between;
    }
    .question_number{
        margin-top: 10px;
    }
    .title_question{
        color:#0071c5;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis!important;
        border: 1px #0071c5 solid !important;
        margin-bottom: 3px;
        margin-top: 3px;
        cursor: pointer;
        border-radius: 5px;
        padding:5px 10px 5px 10px;
    }
    .title_question:hover{
        background-color: #0071c5;
        color: #fff;
    }
    .content_question_left .icon_status_question{
        width: 19px;
        height: 15px;
    }
    .content_question_left {
        color: #000;
        font-size: 12px;
    }
    .content_question_left_top {
        display: flex;
    }
    .content_question_left_top_image{
        margin-right: 34px;
    }
    .content_question_right {
        font-size: 16px;
    }
    .content_question_left_bottom_id{
        margin-right: 10px;
    }
    .content_question_right_top {
        display: flex;
    }
    .question_header {
        width:320px;
        top:5px;
        right:20px;
    }
    .question_search button{
        position: absolute;
    }
    .question_header {
        width: 100%;
        padding: 20px;
        border-radius: 10px;
        box-shadow: 0 0 6px rgba(0, 0, 0, 0.3);
        margin-bottom: 10px;
    }
    .question_header input {
        width:calc(100% - 36px);border:1px solid #DCDFE6;
        height:36px;
        padding:0 5px;
        box-sizing:border-box;
        font-size:13px;
        border-radius:4px 0px 0 4px
    }
    .question_header img {
        width:24px;
    }
    .task_answer_checkbox{
        margin-top: 10px;
        margin-bottom: 10px;
    }
    .task_answer_checkbox span{
        padding-right: 10px;
    }
    .date_picker {
        /* margin-top: 10px; */
    }
    .question_header .question_id {
        width: auto
    }
    .btn-tast {
        float: right;
    }
    .questions_type {
        height: 36px;
        border: 1px solid #dde1e8;
        border-radius: 2px;
        background: #fff;
        cursor: pointer;
    }
    .my_select_organization_disabled {
        color: #c9cccc;
    }
    .my_select_organization_disabled .ds{
        color: #202122!important;
    }
    .my_select_statusQuestionsType_disabled {
        color: #c9cccc;
    }
    .my_select_statusQuestionsType_disabled .ds{
        color: #202122!important;
    }
    .my_select_teachetCeate_disabled {
        color: #c9cccc;
    }
    .my_select_teachetCeate_disabled .ds{
        color: #202122!important;
    }
    .my_select_chapter_disabled {
        color: #c9cccc;
    }
    .my_select_chapter_disabled .ds{
        color: #202122!important;
    }
    /* .question_header {
        min-height: 235px;
    } */
    .reset-form-search-questions {
        float: right;
        width: auto!important;
    }
    .select-option {
        margin-top: 10px;
    }
    /* CSs test */
    .title_question_s{
        color:#0071c5;
        /* white-space: nowrap; */
        overflow: hidden;
        text-overflow: ellipsis!important;
        border: 1px #0071c5 solid !important;
        margin-bottom: 3px;
        margin-top: 3px;
        cursor: pointer;
        border-radius: 5px;
        padding:5px 10px 5px 10px;
    }
    .test_content{
        /* padding-top: 13px; */
        display: -webkit-box;
        -webkit-box-orient: vertical!important;
        -webkit-line-clamp: 1;
        overflow: hidden;
        color:#0071c5;
        font-weight: bold;
        font-size: 16px;
    }
    .title_question_s:hover{
        border: 1px #000 solid !important;
        background-color: rgb(243, 243, 243);
    }
    .title_question_s_header{
        /* color:#a7a4a4;  */
        display: inline;
        color:#666; 
    }
    .icon_status_question {
        width: 19px;
    }
    .icon_type_status_question {
        width: 21px;
    }
    .td_icon_type_status_question{
        float: right;
    }
    .td_padding {
        font-weight: initial;
        padding-right: 5px;
    }
    @media (max-width: 480px) {
        .td_padding {
            padding-right: 0px!important;
        }
    }
    /* CSS test form search */
    .ip-check[type="checkbox"]:checked + label, .ip-check[type="checkbox"]:not(:checked) + label{
        display: inline-block!important;
    }
    @media (max-width: 480px){
        .questions_type {
            width: 100%!important;
            margin-bottom: 10px;
        }
    }
    .question_id {cursor: auto!important;}
    .active_click {
        border: 1px #000 solid !important;
        background-color: rgb(243, 243, 243);
    }
</style>



// WEBPACK FOOTER //
// src/components/manage/question.vue